import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TextTranslationService {
  texts: Record<string, string> = {
    aarlig: 'årlig',
    maanedlig: 'månedlig',
    paakraevet: 'påkrævet',
    kraevet: 'krævet',
    opkraevning_mangler: 'opkrævning mangler',
    bemaerkning: 'bemærkning',
    serviceportal: 'serviceportal',
    raadgiverportal: 'rådgiverportal',
  };

  translate(text: string): string {
    let value = text;
    if (text.toLowerCase) {
      if (
        Object.prototype.hasOwnProperty.call(this.texts, text.toLowerCase())
      ) {
        value = this.texts[text.toLowerCase()];
      }
      if (text.charAt(0) === text.charAt(0).toUpperCase()) {
        value = value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
    return value;
  }
}
